import 'angular';
import * as moment from 'moment';

import {IModalScope} from "../../types/angular-types";
import './approval_levels_modal.html';
import {ApprovalLevelConfig, ApprovalDetailsService, ApprovalStatus} from "../approvals-types";
import './approvalLevelDirective/approvalLevel';

interface ApprovalLevelConfigInModal extends ApprovalLevelConfig {
    approvalType: "ALL" | "SINGLE";
}

interface IScope extends IModalScope {
    // properties
    modalView: {
        title: string,
        levels: ApprovalLevelConfigInModal[]
    }

    // methods
    isLevelConfigValid: (levelConfigs: ApprovalLevelConfig[]) => boolean;
    showRemoveGroupButton: (levelConfig: ApprovalLevelConfig) => boolean;
    isLevelModifiable: (levelConfig: ApprovalLevelConfig) => boolean;
}

ApprovalLevelsModalControllerFn.$inject = ['$scope', '$translate', 'ApprovalDetailsService'];
angular.module("GorillaBoy.Approvals")
.controller('ApprovalLevelsModalController', ApprovalLevelsModalControllerFn);

function ApprovalLevelsModalControllerFn($scope: IScope, $translate: any, ApprovalDetailsService: ApprovalDetailsService) {
    // initialize view model
    $scope.modalView = {
        title: ApprovalDetailsService.getApproval().Title,
        levels: ApprovalDetailsService.getApprovalLevelConfigs().map(approvalLevel2ApprovalLevelInModal)
    };

    if ($scope.modalView.levels.length === 0) {
        $scope.modalView.levels.push(getNewLevelConfig());
    }

    // methods
    $scope.getLevelTitle = (level: ApprovalLevelConfig) => {
        return $translate.instant('APPROVALS.GENERAL.GROUP_TITLE', {
            alphabet: level.LevelNumber
        })
    };

    $scope.isLevelConfigValid = (levelConfigs: ApprovalLevelConfig[]) => {
        return levelConfigs.every((level) => {
            return !level.DueDate || level.approvers.length > 0;
        });
    };

    $scope.isLevelModifiable = (levelConfig: ApprovalLevelConfig) => {
        return levelConfig.status === ApprovalStatus.PENDING || levelConfig.status === ApprovalStatus.QUEUED;
    };

    $scope.showRemoveGroupButton = (levelConfig: ApprovalLevelConfig) => {
        return $scope.modalView.levels.length > 1 && $scope.isLevelModifiable(levelConfig);
    };

    $scope.onOkClicked = function() {
        updateApprovalLevelConfigs();
        $scope.$close();
    };

    $scope.addGroupClickHandler = () => {
        $scope.modalView.levels.push(getNewLevelConfig());
    };

    $scope.removeGroupClickHandler = ($event, level: ApprovalLevelConfig) => {
        $scope.modalView.levels = $scope.modalView.levels.filter((lev: ApprovalLevelConfig) => lev.LevelNumber !== level.LevelNumber);
        //recalculate the level numbers
        $scope.modalView.levels.forEach((level, idx) => {
            level.LevelNumber = idx + 1;
        });
        // uib-accordion-heading adds very complex listeners to the DOM. prevent default and propagation to avoid unexpected behaviors
        $event.preventDefault();
        $event.stopPropagation();
    };

    // Helper functions
    function getNewLevelConfig(): ApprovalLevelConfigInModal {
        let levelConfig: ApprovalLevelConfigInModal = {
            LevelNumber: $scope.modalView.levels.length + 1,
            // the due day of each level must increase...
            DueDate: moment().add(5 + $scope.modalView.levels.length,'days').hour(17).minute(0).toDate().toISOString(),
            RemindersInSeconds: null,
            CompleteDate: null,
            MinimumApprovalsRequired: null,
            approvalType: 'ALL',
            approvers: [],
            visible: true,
            status: ApprovalStatus.QUEUED
        };
        return levelConfig;
    }

    function updateApprovalLevelConfigs() {
        ApprovalDetailsService.setApprovalLevelConfigs($scope.modalView.levels.map(approvalLevelInModal2ApprovalLevel));
    }

    function approvalLevel2ApprovalLevelInModal(levelConfig: ApprovalLevelConfig) : ApprovalLevelConfigInModal {
        let result: ApprovalLevelConfigInModal = {
            LevelNumber: levelConfig.LevelNumber,
            DueDate: levelConfig.DueDate,
            RemindersInSeconds: levelConfig.RemindersInSeconds,
            CompleteDate: levelConfig.CompleteDate,
            MinimumApprovalsRequired: levelConfig.MinimumApprovalsRequired,
            approvers: levelConfig.approvers,
            visible: levelConfig.visible,
            approvalType: levelConfig.approvers.length === levelConfig.MinimumApprovalsRequired ? "ALL": "SINGLE",
            status: levelConfig.status
        }
        return result;
    }

    function approvalLevelInModal2ApprovalLevel(levelConfigInModal: ApprovalLevelConfigInModal) : ApprovalLevelConfig {
        let minApprovalsRequried = 0;
        if (levelConfigInModal.approvalType === 'ALL') {
            minApprovalsRequried = levelConfigInModal.approvers.length;
        } else if (levelConfigInModal.approvalType === 'SINGLE') {
            minApprovalsRequried = 1;
        }
        let result: ApprovalLevelConfig = {
            LevelNumber: levelConfigInModal.LevelNumber,
            DueDate: levelConfigInModal.DueDate,
            RemindersInSeconds: levelConfigInModal.RemindersInSeconds,
            CompleteDate: levelConfigInModal.CompleteDate,
            MinimumApprovalsRequired: minApprovalsRequried,
            approvers: levelConfigInModal.approvers,
            visible: levelConfigInModal.visible,
            status: levelConfigInModal.status
        }
        return result;
    }
}
